import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MonthSelector from './monthselector';
import DaySelector from './dayselector';
import YearSelector from './yearselector';
import FilterButton from './filterbutton';
import moment from 'moment';
import UserYearFilter from './userYearFilter';
import '../assets/styles/userDisplay.css'
import { useAuth } from './Auth/AuthContext';
import { API_BASE_URL } from '../config/api';

const UserDisplay = () => {
    const location = useLocation();
    const { name } = location.state || {};
    const navigate = useNavigate();
    const [sessionData, setSessionData] = useState([]);
    const [filteredSessions, setFilteredSessions] = useState([]);

    const [userID, setUserID] = useState([])

    const [monthSelected, setSelectedMonth] = useState('Month')
    const [daySelected, setSelectedDay] = useState('Day')
    const [yearSelected, setSelectedYear] = useState('Year')
    const [validResult, setValidResult] = useState(true);
    const monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const { token } = useAuth();
    
    useEffect(() => {
        const fetchSessions = async () => {
            try {
                const idResponse = await fetch(`${API_BASE_URL}/attendance/users/name/${name}`, {
                    'headers': {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!idResponse.ok) {
                    throw new Error('Network response was not ok');
                }
                const idData = await idResponse.json();
                const userId = idData.UserID
                setUserID(userId)
                console.log(userId)

                const sessionResponse = await fetch(`${API_BASE_URL}/attendance/users/${userId}/sessions`, {
                    'headers': {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!sessionResponse.ok) {
                    throw new Error('Network response was not ok');
                }
                const sessionData = await sessionResponse.json();
                console.log(sessionData)
                setSessionData(sessionData)
                setFilteredSessions(sessionData)
                setValidResult(true);
            } catch (error) {
                console.error('Fetch error:', error);
                setValidResult(false);
            }
          };

          if(name && token) {
            fetchSessions();
          }
    }, [name, token]);

    const getSessionParts = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number);
        return { year, month, day };
    }

    const handleSessionClick = (month, day, year) => {
        //const selectedMonth = event.target.textContent
        //console.log(selectedMonth)
        const monthStr = monthArr[month - 1]
        navigate(`/attendees/${year}/${monthStr}/${day}`);
    }

    const handleMonthChange = (month) => {
        setSelectedMonth(month);
    };

    const handleDayChange = (day) => {
        setSelectedDay(day);
    };

    const handleYearChange = (year) => {
        setSelectedYear(year);
    };

    const handleReset = () => {
        setSelectedMonth('Month');
        setSelectedDay('Day');
        setSelectedYear('Year');
        setFilteredSessions(sessionData);
    }

    const handleSubmitClicked = () => {
        const isMonthSelected = monthSelected !== 'Month';
        const isDaySelected = daySelected !== 'Day';
        const isYearSelected = yearSelected !== 'Year';

        if(isMonthSelected && isDaySelected && !isYearSelected) {
            return;
        }

        const selectedMonthNum = isMonthSelected
            ? monthArr.indexOf(monthSelected) + 1
            : null;

        const results = sessionData.filter((session) => {
            const { year, month, day } = getSessionParts(session.Date);

            const yearMatch = !isYearSelected || year === Number(yearSelected);
            const monthMatch = !isMonthSelected || month === selectedMonthNum;
            const dayMatch = !isDaySelected || day === Number(daySelected);

            return yearMatch && monthMatch && dayMatch;
        });

        setFilteredSessions(results);
    }

    // const fetchFilteredSessions = async () => {
    //     const monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    //     if(monthSelected !== "Month" && daySelected !== "Day" && yearSelected !== "Year") {
    //         if(monthArr.indexOf(monthSelected) < 0) {
    //             throw new Error("Invalid month provided")
    //         }
    //         try {
    //             const response = await fetch(`http://localhost:3002/attendance/users/${userID}/session/${yearSelected}-${monthArr.indexOf(monthSelected) + 1}-${daySelected}`, {
    //                 'headers': {
    //                     'Authorization': `Bearer ${token}`
    //                 }
    //             });
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             const data = await response.json();
    //             setSessionData(data)
    //         } catch (error) {
    //             console.error('Fetch error:', error);
    //         } finally {
    //         }
    //     }
    //     else if(monthSelected !== "Month" && daySelected === "Day" && yearSelected !== "Year") {
    //         if(monthArr.indexOf(monthSelected) < 0) {
    //             throw new Error("Invalid month provided")
    //         }
    //         try {
    //             const response = await fetch(`http://localhost:3002/attendance/users/${userID}/session/${yearSelected}/${monthArr.indexOf(monthSelected) + 1}`, {
    //                 'headers': {
    //                     'Authorization': `Bearer ${token}`
    //                 }
    //             });
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             const data = await response.json();
    //             setSessionData(data)
    //         } catch (error) {
    //             console.error('Fetch error:', error);
    //         } finally {
    //         }
    //     }
    //   };

    return(
        <div className='container'>
            <div className='uumc-page-label'>Filter by user</div>
            <h1 className='uumc-page-title'>{name}</h1>

            <div className={!validResult ? 'visible' : 'hidden'}>
              <div>No results found for {name}. Please try another search</div>
              <button className='return-home' onClick={() => {navigate('/')}}>Back to Home</button>
            </div>

            <div className={validResult ? 'visible' : 'hidden'}>

                <div className="uumc-user-top-grid">
                    <div className="uumc-profile-card">
                        <div className="uumc-avatar">
                            {name?.split(' ').map(n => n[0]).join('').toUpperCase()}
                        </div>
                        <div className="uumc-profile-name">{name}</div>
                        <div className="uumc-profile-meta">UUMC</div>
                        <div className="uumc-profile-badge">Member</div>
                    </div>
                    <div className="uumc-stat-grid">
                        <div className="uumc-stat-card">
                            <div className="uumc-stat-label">Total sessions</div>
                            <div className="uumc-stat-value">{sessionData.length}</div>
                        </div>
                        <div className="uumc-stat-card">
                            <div className="uumc-stat-label">This year</div>
                            <div className="uumc-stat-value">—</div>
                        </div>
                        <div className="uumc-stat-card">
                            <div className="uumc-stat-label">First session</div>
                            <div className="uumc-stat-value uumc-stat-sm">{sessionData[0]?.Date || '—'}</div>
                        </div>
                        <div className="uumc-stat-card">
                            <div className="uumc-stat-label">Last session</div>
                            <div className="uumc-stat-value uumc-stat-sm">{sessionData[sessionData.length - 1]?.Date || '—'}</div>
                        </div>
                    </div>
                </div>

                <div className="filter-box row" data-testid="filter-by-date-card">
                    <h3>Filter by date:</h3>
                    <div className="uumc-filter-top">
                        <h3>Filter by date:</h3>
                        <button className="uumc-reset-btn" onClick={handleReset} data-testid="date-filter-reset">↺ Reset</button>
                    </div>
                    <div></div>
                    <div className="col">
                        <MonthSelector value={monthSelected} onMonthChange={handleMonthChange}/>
                    </div>
                    <div className="col">
                        <DaySelector value={daySelected} onDayChange={handleDayChange}/>
                    </div>
                    <div className="col">
                        <YearSelector value={yearSelected} onYearChange={handleYearChange}/>
                    </div>
                    <FilterButton onClick={handleSubmitClicked} testId="date-filter-submit"/>
                </div>
                
                <div className="uumc-sessions-card" data-testid="user-session-card">
                    <div className="uumc-sessions-header">Session history</div>
                    {filteredSessions.map(session => (
                        <div
                            key={session.SessionID}
                            className="uumc-session-row"
                            onClick={() => {
                                const [year, month, day] = session.Date.split('-');
                                handleSessionClick(Number(month), Number(day), Number(year));
                            }}
                            data-testid="session-card"
                        >
                            <div className="uumc-session-left">
                                <div className="uumc-session-dot"></div>
                                <span className="uumc-session-date" data-testid="session-date">{session.Date}</span>
                            </div>
                            <span className="uumc-session-arrow">→</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default UserDisplay;